import {
    Column,
    Format,
    Lookup
} from 'devextreme-react/data-grid';

import { useGetChangeOrders } from "../api/get-change-orders";
import { ChangeOrderGridProps } from '../types/ChangeOrderGridProps';
import { Link, useLocation } from 'react-router-dom';
import { LoadPagePanel, SyncDataGrid } from '../../../../components';
import { useCallback } from 'react';

export default function ChangeOrderGrid(props: ChangeOrderGridProps) {
    const orders = useGetChangeOrders(props.changeOrderStatus);
    const location = useLocation();
    const returnUrl = encodeURIComponent(location.pathname + location.search);

    const roNumberCellRender = useCallback((row: any) => {
        return <Link to={`/cfi/retail-order/${row.data.retailOrderID}/120?returnUrl=${returnUrl}`}>
            {row.data.roNumber}
        </Link>;
    }, [returnUrl]);

    const actionRequiredCellRender = useCallback((row: any) => {
        return <Link to={`/cfi/retail-order/${row.data.retailOrderID}/120?returnUrl=${returnUrl}`}>
            {row.data.actionDescription}
        </Link>;
    }, [returnUrl]);

    const quoteNumberCellRender = useCallback((cell: any) => {
        if (cell.data.quoteID)
            return <Link to={`/cfi/estimate/${cell.data.quoteID}`}>
                {cell.data.quoteNumber}
            </Link>
        else
            return <>{cell.data.quoteNumber}</>;
    }, []);

    return (
        <>
            <SyncDataGrid
                stateStorageKey={'change-order-grid'}
                className={'dx-card wide-card'}
                dataSource={orders.data?.orders}
                keyExpr={'retailOrderID'}
                height="68vh"
            >
                <Column
                    dataField={'roNumber'}
                    caption={'Order #'}
                    dataType="string"
                    cellRender={roNumberCellRender}
                />
                <Column
                    dataField={'projectNumber'}
                    caption={'Project #'}
                    dataType="string"
                />
                <Column
                    dataField={'actionRequiredID'}
                    caption={'Action Required'}
                    dataType="string"
                    cellRender={actionRequiredCellRender}
                    editorOptions={{
                        dropDownOptions: {
                            minWidth: 270
                        }
                    }}
                >
                    <Lookup
                        dataSource={orders.data?.actionsRequired}
                        valueExpr={'actionRequiredID'}
                        displayExpr={'description'}
                    />
                </Column>
                <Column
                    dataField={'changeOrderTypeID'}
                    calculateDisplayValue={'changeOrderTypeName'}
                    caption={'Order Type'}
                    dataType="string"
                    editorOptions={{
                        dropDownOptions: {
                            minWidth: 150,
                        }
                    }}
                >
                    <Lookup
                        dataSource={orders.data?.changeOrderTypes}
                        valueExpr={'lookupID'}
                        displayExpr={'displayValue'}
                    />
                </Column>
                {
                    !props.changeOrderStatus &&
                    <Column
                        dataField={'changeOrderStatusID'}
                        calculateDisplayValue={'changeOrderStatusName'}
                        caption={'Pending Change Order Status'}
                        dataType="string"
                        editorOptions={{
                            dropDownOptions: {
                                minWidth: 150,
                            }
                        }}
                    >
                        <Lookup
                            dataSource={orders.data?.changeOrderStatuses}
                            valueExpr={'lookupID'}
                            displayExpr={'displayValue'}
                        />
                    </Column>
                }
                <Column
                    dataField={'amount'}
                    caption={'Order Amount'}
                    dataType="number"
                    editorOptions={{ format: '$#,##0.##', showClearButton: true }}
                >
                    <Format type="currency" precision={2}></Format>
                </Column>
                <Column
                    dataField={'parentCompanyID'}
                    caption={'Parent Company'}
                    dataType="string"
                    editorOptions={{
                        dropDownOptions: {
                            minWidth: 150,
                        }
                    }}
                >
                    <Lookup
                        dataSource={orders.data?.retailers}
                        valueExpr="companyID"
                        displayExpr="companyName"
                    />
                </Column>
                <Column
                    dataField={'dealerNumber'}
                    caption={'Store #'}
                    dataType="string"
                />
                <Column
                    dataField={'proxyStoreNumber'}
                    caption={'Proxy Store #'}
                    dataType="string"
                />
                <Column
                    dataField={'dealerPhone'}
                    caption={'Store Phone #'}
                    dataType="string"
                />
                <Column
                    dataField={'productLine'}
                    caption={'Product Line'}
                    dataType="string"
                />
                <Column
                    dataField={'roDate'}
                    caption={'Order Date'}
                    dataType="date"
                />
                <Column
                    dataField={'measureDate'}
                    caption={'Measure Date'}
                    dataType="date"
                />
                <Column
                    dataField={'enterTemplateDate'}
                    caption={'Template Date'}
                    dataType="date"
                />
                <Column
                    dataField={'changeRequestDate'}
                    caption={'Change Request Date'}
                    dataType="date"
                />
                <Column
                    dataField={'quoteNumber'}
                    caption={'Estimate Number'}
                    dataType="string"
                    cellRender={quoteNumberCellRender}
                />
                <Column
                    dataField={'customerName'}
                    caption={'Customer Name'}
                    dataType="string"
                />
                <Column
                    dataField={'customerPhone'}
                    caption={'Customer Phone #'}
                    dataType="string"
                />
                <Column
                    dataField={'customerAddress'}
                    caption={'Address'}
                    dataType="string"
                />
                <Column
                    dataField={'customerCityZip'}
                    caption={'City/State,Zip'}
                    dataType="string"
                />


            </SyncDataGrid>

            <LoadPagePanel visible={orders.isLoading} />
        </>
    )
} 
